import React from 'react';
import { ItemKinds } from 'enums/items';
import { ExternalItemsList } from '../components';
import {} from './PartnershipRequestItems.types';
const PartnershipRequestItems = ({ partnershipItems }) => (React.createElement(ExternalItemsList, { itemsKind: ItemKinds.PAYABLE, partnershipItems: partnershipItems }));
export default PartnershipRequestItems;
